/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { appControllerGetHello } from "./appControllerGetHello";

export function appService() {
  return { appControllerGetHello }
}